import { render, staticRenderFns } from "./RoleAuth.vue?vue&type=template&id=2d0f8fc4"
import script from "./RoleAuth.vue?vue&type=script&lang=js"
export * from "./RoleAuth.vue?vue&type=script&lang=js"
import style0 from "./RoleAuth.vue?vue&type=style&index=0&id=2d0f8fc4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports